"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const stepper_1 = __importStar(require("@kyruus/stepper"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const DesktopHeaderSkeleton_1 = __importDefault(require("./DesktopHeaderSkeleton"));
const config_1 = require("../../lib/constants/config");
const BackToSearchButton_1 = __importDefault(require("./BackToSearchButton"));
const DesktopHeader = (0, react_1.forwardRef)(({ activeStep, onGoBack, stepsConfiguration, searchMatchEnabled, backToSearchPageURL, isOrderBasedSchedulingFlow, track, intl }, ref) => {
    if (!stepsConfiguration) {
        return (react_1.default.createElement(styles_1.Container, { "data-testid": "HeaderSkeleton", ref: ref },
            react_1.default.createElement(DesktopHeaderSkeleton_1.default, null)));
    }
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "Header", id: config_1.HEADER_ELEMENT_ID, aboveMd: true, ref: ref },
        react_1.default.createElement(styles_1.StepperContainer, null,
            react_1.default.createElement(BackToSearchButton_1.default, { backToSearchPageURL: backToSearchPageURL, searchMatchEnabled: searchMatchEnabled, isOrderBasedSchedulingFlow: isOrderBasedSchedulingFlow, track: track }),
            react_1.default.createElement(stepper_1.default, { orientation: "horizontal", activeStep: activeStep }, stepsConfiguration
                .filter(({ stepperLabelId }) => stepperLabelId !== 'appointmentConfirmedTitle')
                .map(({ stateKey, stepperLabelId, ariaLabelId }, index) => {
                var _a;
                return (react_1.default.createElement(stepper_1.Step, { key: stepperLabelId, "data-testid": stepperLabelId },
                    react_1.default.createElement(stepper_1.StepLabel, null, index < activeStep ? (react_1.default.createElement(styles_1.StyledButton, { "data-testid": `${(_a = messages_1.default[stepperLabelId]) === null || _a === void 0 ? void 0 : _a.defaultMessage}-button`, mode: "flat", "aria-label": intl.formatMessage(messages_1.default[ariaLabelId]), onClick: () => onGoBack(stateKey) },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[stepperLabelId])))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[stepperLabelId]))))));
            })))));
});
DesktopHeader.displayName = 'DesktopHeader';
DesktopHeader.propTypes = {
    // active step to highlight
    activeStep: prop_types_1.string.isRequired,
    // callback for 'back' click
    onGoBack: prop_types_1.func.isRequired,
    // steps configuration object. see constants/steps
    stepsConfiguration: prop_types_1.object,
    // to check if search match is enabled
    searchMatchEnabled: prop_types_1.bool.isRequired,
    backToSearchPageURL: prop_types_1.string,
    track: prop_types_1.func.isRequired,
    isOrderBasedSchedulingFlow: prop_types_1.bool,
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }).isRequired
};
exports.default = (0, intl_1.injectIntl)(DesktopHeader);
//# sourceMappingURL=DesktopHeader.js.map